<template>
  <md-card v-if="currentAsset.length" class="exchange-rates">
    <md-card-header class="exchange-rates__header">
      <div class="md-title">{{ i18n.lbl_exchange_rates({ asset: currentAsset || 'assets' }) }}</div>
    </md-card-header>
    <md-card-content class="exchange-rates__rates">
      <md-table>
        <md-table-row class="exchange-rates-table__header">
          <md-table-head class="ex-currency">{{ i18n.lbl_exchange_asset() }}</md-table-head>
          <md-table-head class="ex-buy">{{ i18n.lbl_exchange_buy() }}</md-table-head>
        </md-table-row>
        <template v-for="(item, i) in list">
          <md-table-row class="exchange-rates__rates-items">
            <md-table-cell class="ex-currency">
              <md-radio class="md-primary"
                        v-model="convertAsset"
                        v-bind:value="item.quote">{{ item.quote }}</md-radio>
            </md-table-cell>
            <md-table-cell class="ex-buy">
              {{ priceBuy(item) }}
            </md-table-cell>
          </md-table-row>
        </template>
      </md-table>
    </md-card-content>

    <info-dialog v-on:close-dialog="closeDialog"
                 v-if="showDialog"
                 :dialogValues="dialogValues"
                 :showDialog="showDialog"/>
  </md-card>
</template>

<script>
  import { i18n } from '@js/i18n'
  import { round } from '@utils/math.util'

  export default {
    name: 'exchange-rates',
    data: _ => ({
      convertAsset: '',
      pairs: [],
      i18n
    }),
    props: ['currentAsset'],
    computed: {
      list () {
        this.convertAsset = ''
        return (this.pairs = this.$parent.getList())
      }
    },
    methods: {
      convertAmount (asset) {
        const item = this.pairs.find(pair => pair.quote === asset)
        if (item !== undefined) {
          this.convertAsset = asset
          this.$parent.$emit('convert-amount', {convertAsset: this.convertAsset})
        }
      },
      priceBuy (item) {
        return item.price ? round(item.price, 5).toString() : ''
      }
    },
    watch: {
      'convertAsset': function (value) { this.convertAmount(value) }
    }
  }
</script>

<style lang="scss" scoped>

  @import '~scss/variables.scss';
  @import '~scss/mixins.scss';

  .exchange-rates {
    max-width: 560px;
    width: 100%;
    min-width: 248px;
    display: flex;
    flex-direction: column;

    @include respond-to(medium) {
      max-width: inherit;
    }

    /deep/ .md-table-cell-container {
      padding: 6px 12px;
    }
  }

  .exchange-rates__header {
    padding-bottom: 48px;
  }

  .ex-head-currency { width: 20%; text-align: left; }
  .ex-head-buy { width: 40%; text-align: center;}

</style>



// WEBPACK FOOTER //
// src/vue/app/exchange/index/Exchange.Rates.vue